import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class PoolIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 217.96">
                <path
                    d="M.07 100.31c3.3 1 6.29 1.72 9.18 2.78a52.12 52.12 0 0 1 21.1 14.3 16.67 16.67 0 0 0 24.87.18c16.32-17.25 35.93-22.08 58.44-14.93 8.53 2.71 15.65 7.85 21.67 14.46 7.22 7.93 18.28 8 25.44.09a53.77 53.77 0 0 1 80.11.29c7.28 8.17 18.53 7.93 25.84-.2 8.74-9.72 19.82-15.21 33-17.07.09.85.23 1.57.23 2.29 0 9-.05 18 .06 26.94 0 1.89-.76 2.54-2.29 3.42a32.7 32.7 0 0 0-8 5.79c-19.82 21.73-52.49 21.7-72.15-.2a22.46 22.46 0 0 0-33.85.05c-18.57 21-51.88 21.25-70.92.5-10.1-11.02-24.7-11.02-34.8.06-18.63 20.51-51.81 20.43-70.57-.15a15.45 15.45 0 0 0-4.1-3.69c-2.9-1.45-3.38-3.59-3.33-6.58.19-9.25.07-18.51.07-28.33z"
                    fill={color}
                />
                <path
                    d="M42.79 109.25a9.65 9.65 0 0 0 7-3.15c8.37-8.85 17.68-14.8 27.79-17.91l50.08-35.39-27.33-12.49L72.4 73.04a20.15 20.15 0 0 1-15.48 7.11 23.45 23.45 0 0 1-12.49-3.58 19.82 19.82 0 0 1-2.38-27.94L73 11.76a33.09 33.09 0 0 1 38.65-8.91s56.51 25 74.95 33.89c5.35 1.8 10.72 6 16.06 13.09 6 8.34 24.4 34.5 24.4 34.5a37.2 37.2 0 0 1 5.23 10.13 61.28 61.28 0 0 1 14.17 11.7 9.57 9.57 0 0 0 7.17 3.53 10.35 10.35 0 0 0 7.59-3.75c8.7-9.67 19.87-15.74 33-18.47V-.02H35.52v105.7c.11.12.24.23.35.35a9.27 9.27 0 0 0 6.92 3.22zm186-98.07c16.64-11.9 41-8.33 52.94 8.91s7.72 41-8.91 52.95a37.46 37.46 0 0 1-52.94-9c-11.88-17.2-7.72-40.98 8.92-52.86z"
                    fill="none"
                />
                <path
                    d="M115.9 89.18c9.19 2.92 17.57 8.48 24.92 16.54a10 10 0 0 0 7.31 3.55 9.57 9.57 0 0 0 7.12-3.45 61.07 61.07 0 0 1 77-11.37A37.2 37.2 0 0 0 227 84.33s-18.44-26.16-24.4-34.5c-5.34-7.14-10.71-11.29-16.06-13.09-18.44-8.91-74.95-33.89-74.95-33.89A33.09 33.09 0 0 0 73 11.76L42.05 48.64a19.82 19.82 0 0 0 2.38 27.94 23.45 23.45 0 0 0 12.49 3.58 20.15 20.15 0 0 0 15.48-7.11l27.94-32.73 27.35 12.49L77.6 88.18a56.86 56.86 0 0 1 16.79-2.54 71.31 71.31 0 0 1 21.51 3.54zM272.82 73.04c16.64-11.91 20.79-35.69 8.91-52.95S245.44-.72 228.8 11.18s-20.8 35.66-8.91 52.91a37.46 37.46 0 0 0 52.93 8.95zM.07 163.36c3.3 1 6.29 1.72 9.18 2.78a52.12 52.12 0 0 1 21.1 14.3 16.67 16.67 0 0 0 24.87.18c16.32-17.25 35.93-22.08 58.44-14.93 8.53 2.71 15.65 7.85 21.67 14.46 7.22 7.93 18.28 8 25.44.09a53.77 53.77 0 0 1 80.11.29c7.28 8.17 18.53 7.93 25.84-.2 8.74-9.72 19.82-15.21 33-17.07.09.85.23 1.57.23 2.29 0 9-.05 18 .06 26.94 0 1.89-.76 2.54-2.29 3.42a32.7 32.7 0 0 0-8 5.79c-19.82 21.73-52.49 21.7-72.15-.2a22.46 22.46 0 0 0-33.85.05c-18.57 21-51.88 21.25-70.92.5-10.1-11.07-24.7-11.07-34.8.05-18.6 20.52-51.78 20.43-70.54-.12a15.45 15.45 0 0 0-4.1-3.69c-2.93-1.47-3.41-3.61-3.36-6.6.19-9.25.07-18.51.07-28.33z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(PoolIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/PoolIcon.js